// https://vuex.vuejs.org/en/state.html

export default {
  authStatus: '',
  token: localStorage.getItem('token') || '',
  user: localStorage.getItem('user') || '', //{}
  username: localStorage.getItem('username') || '',
  rolusuario: localStorage.getItem('rolusuario') || 0,
  rolesusuario: localStorage.getItem('rolesusuario') || [],
  rolesid: localStorage.getItem('rolesid') || [],
  permisos: localStorage.getItem('permisos') || [],
  vencimiento: localStorage.getItem('validohasta') || null,
  foto: localStorage.getItem('foto') || '',
  idestado: localStorage.getItem('idestado') || 0,
  iddelegacion: localStorage.getItem('iddelegacion') || 0,
  mensaje: localStorage.getItem('mensaje') || '',
  tableList: []
}
